/** @jsx jsx */
import { jsx } from '@emotion/core';
import { get } from 'lodash';
import { Container } from '../../../styles/Grid';

import { SafePureComponent } from '../../../utils/SafePureComponent';
import Spacer from '../../ui/Spacer';

import NewTopLocationMenu from '../NavigationV2/NewTopLocationMenu';
import * as styles from './index.styles';

class TopLocation extends SafePureComponent {
  safeRender() {
    const { fields } = this.props;
    console.log('** TopLocation fields', fields);
    const SeoList = get(fields, 'SEO_LIST.value', {});
    // const richFiltering = get(RichFiltering, 'value', false);
    return (
      <Spacer marginCss={[styles.containerMargin]}>
        <Container>
          <NewTopLocationMenu SeoList={SeoList} isFromNav={false} />
        </Container>
      </Spacer>
    );
  }
}

TopLocation.displayName = 'Top Location';

export default TopLocation;
